import React, { useEffect, useState } from 'react';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Nav, NavItem, NavLink, Row } from 'reactstrap';

// Componentes
import MainCard from '../../../../../components/MainCard';
import Identificacao from './Identificacao';
import PermissoesPerfil from './PermissoesPerfil';
import EtapasFiscalizacao from './EtapasFiscalizacao';

// Helpers
import { showMessage } from '../../../../../helpers/message';

// API
import perfil_api from '../../../../../api/perfil_api';
import roteiroDeFiscalizacao_api from '../../../../../api/roteiroDeFiscalizacao_api';

// Context
import { useAuth } from '../../../../../context/auth';

function initialStatePerfil(secretaria_id = 4) {
    return {
        identificacao: "",
        status: "Ativo",
        Secretaria_Id: secretaria_id
    }
}

function CadastroPerfil({ id = null, handleVoltar, editavel = false }) {
    //State para criar/editar
    const [perfil, setPerfil] = useState(initialStatePerfil());

    //State para guarda as fiscalizações de etapas
    const [listFiscalizacaoEtapas, setListFiscalizacaoEtapas] = useState([]);

    //State de controle do passo ativo
    const [activeStep, setActiveStep] = useState(1);

    const { setLoading } = useAuth();

    async function loadFiscalizacaoEtapas(){
        try {
            const { data } = await roteiroDeFiscalizacao_api.GetAllFiscalizacaoEtapas();
            setListFiscalizacaoEtapas(data || []);
        } catch (e) {
            showMessage("Erro", e.message, "error", null);
        } finally {
            setLoading(false);
        }
    }

   async function loadPerfilItem(id) {
        if (id != null || perfil.id != null) {
            try {
                const response = await perfil_api.getItem(id ?? perfil.id);
                setPerfil(response.data);
            } catch (e) {
                showMessage("Erro", e.message, "error", null);
            } finally {
                setLoading(false);
            }
        }
    }

    useEffect(() => {
        loadPerfilItem(id);
        loadFiscalizacaoEtapas();
    }, [])

    //Função que retorna o valor do passo ativo
    const getContent = () => {
        switch (activeStep) {
            case 1:
                return <Identificacao
                    perfil={perfil}
                    setPerfil={setPerfil}
                    loadPerfilItem={loadPerfilItem}
                    editavel={editavel}
                />
            case 2:
                return <PermissoesPerfil
                    perfil={perfil}
                    setPerfil={setPerfil}
                    handleVoltar={handleVoltar}
                    editavel={editavel}
                />
            case 3:
                return <EtapasFiscalizacao
                    perfil={perfil}
                    setPerfil={setPerfil}
                    handleVoltar={handleVoltar}
                    editavel={editavel}
                    listFiscalizacaoEtapas={listFiscalizacaoEtapas}
                />
            default:
                return <></>;
        }
    }

    return <>
        <Button
            onClick={handleVoltar}
            className='px-4'>
            <FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Voltar
        </Button>
        <MainCard>
            <h4 style={{ color: "#666" }}>Perfil</h4>
            <Nav tabs>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={{ backgroundColor: activeStep == 1 ? "#fff" : "#ccc" }}
                        className={`${activeStep == 1 ? "active fw-bold text-success" : "text-secondary "}`}
                        onClick={() => { setActiveStep(1); }}
                    >
                        Dados de Identificação
                    </NavLink>
                </NavItem>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={{ backgroundColor: activeStep == 2 ? "#fff" : "#ccc" }}
                        className={`${activeStep == 2 ? "active fw-bold text-success" : "text-secondary "}`}
                        onClick={() => {
                            if (!perfil.id) {
                                showMessage("Aviso", "Salve a Identificação do Perfil para passar para outra etapa.", "info", null);
                                return;
                            }

                            setActiveStep(2);
                        }}
                    >
                        Permissões de Acesso
                    </NavLink>
                </NavItem>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={{ backgroundColor: activeStep == 3 ? "#fff" : "#ccc" }}
                        className={`${activeStep == 3 ? "active fw-bold text-success" : "text-secondary "}`}
                        onClick={() => {
                            if (!perfil.id) {
                                showMessage("Aviso", "Salve a Identificação do Perfil para passar para outra etapa.", "info", null);
                                return;
                            }

                            setActiveStep(3);
                        }}
                    >
                        Etapas de Fiscalização
                    </NavLink>
                </NavItem>
            </Nav>
            <div className="mt-4">
                {getContent()}
            </div>
        </MainCard>
    </>;
}

export default CadastroPerfil;